'use client'

import { Section } from '@/frontend/legacy/components/Page/Section'
import { Headline } from '@/frontend/legacy/components/Page/HeadlineContainer'
import GridRow from '@/frontend/legacy/components/Grid/Row'
import GridCol from '@/frontend/legacy/components/Grid/Col'
import AccordionItem from '@/frontend/legacy/components/Elements/AccordionItem'
import { ButtonContainer } from '@/frontend/components/ui/button'
import { CTAArray } from '@/frontend/components/ui/content/cta-elements'

export const AccordionComponent = ({ content }) => {
  return (
    <Section
      additionalClass={`accordion-component background-color-1`}
      id={content.blockName}
      sectionSpacing={content.secSpaceGrp.secSpace}
      sectionSpacingSize={content.secSpaceGrp.secSpaceSize}
    >
      <div className="accordion-element-container">
        <GridRow>
          {content.heading ? (
            <GridCol size="xs-12 m-4 l-5 headline-column">
              <Headline
                headline={content.headlineContainer?.heading}
                tag={content.headlineContainer?.headingTag}
                subline={content.headlineContainer?.subline}
                roofline={content.headlineContainer?.roofline}
                inlineComponent={false}
              />
              {content.column.cta ? (
                <ButtonContainer alignment="left">
                  <CTAArray ctaArray={[{ cta: content.cta }]} />
                </ButtonContainer>
              ) : null}
            </GridCol>
          ) : null}
          <GridCol size="xs-12 m-8 l-7">
            <ul className="accordion-list">
              {content.accordionElements
                ? content.accordionElements.map((item, index) => (
                    <AccordionItem item={item} key={index} />
                  ))
                : null}
            </ul>
          </GridCol>
        </GridRow>
      </div>
    </Section>
  )
}

export default AccordionComponent
